function setCookie(key, value) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}

function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}

jQuery(function($){
  var $nl_html = $('#newsletter-popup-html');
  var $popupOpen = false;

   $(document).on('click', function(event) { 
     if($popupOpen==false && $nl_html.length && getCookie('hide_newsletter_popup')!=1){
       event.preventDefault();
       openNewsletterPopup();
     }
   });
   $(document).on('mousemove', function(event) {
     openNewsletterPopup();
   });
    $(window).on('scroll', function() {
      openNewsletterPopup();
    });
    $(window).on('resize', function() {
      openNewsletterPopup();      
    });

  function openNewsletterPopup(){
    if($popupOpen==false && $nl_html.length && getCookie('hide_newsletter_popup')!=1){
      $popupOpen = true;
      $('body').append('<div class="newsletter_popup popup-overlay">'+ $nl_html.html() +'</div>');
      $('.newsletter_popup').fadeIn('3000');
    }
  }

  $(document).on("click","a.newsletter_popup_close",function() {
      $('.newsletter_popup').fadeOut('3000');
      setCookie('hide_newsletter_popup','1');
      return false;
  });
  
});

function checkLimitedCartProducts(adding_to_cart){
  var limited_products = $('.limited-product');
  var cart_count = parseInt($('#cart-icon-bubble span:last-child').text());
  if(limited_products.length && cart_count > 0 && $('body').hasClass('template-cart')){
    $.ajax({
        type: 'GET',url: '/cart',dataType: 'json',async: false,
        success: function(cart) {
          for (var i = 0; i < cart.items.length; i++) {
            limited_products.each(function(){
              var limited_product_elem = $(this);
              var limited_product_handle = $(this).data('limited-product');
              if (cart.items[i].handle === limited_product_handle) {
                var can_remove_limit_product = true;
                var limit_to_products = limited_product_elem.find('.limit-to-product');
                if(limit_to_products.length){
                  limit_to_products.each(function(){
                    for (var j = 0; j < cart.items.length; j++) {
                      var limit_to_product_handle = $(this).data('limit-to-product');
                      if (cart.items[j].handle === limit_to_product_handle) {
                        can_remove_limit_product = false;
                        break;
                      }                 
                    }
                  });
                }
                if(can_remove_limit_product == true){
                  $.ajax({
                    type: 'POST',
                    url: '/cart/change.js',
                    data: {id: cart.items[i].id,quantity: 0},
                    dataType: 'json',
                    success: function(cart) {
                      if($('body').hasClass('template-cart')){
                        window.location.reload();
                      }
                      reloadCarts();
                      //disableCheckoutButton();
                    },
                    error: function(error) {
                      reloadCarts();
                      //disableCheckoutButton();
                    }
                  });
                }
              }
            });
          }
        },
        error: function(xhr, status, error) {
            console.error('Limit check failed. Error fetching cart: ' + error);
        }
    });
  }
  setTimeout(function(){
    checkLimitedCartProducts(false);
  },3000);
}
function reloadCarts(){
  $('#cart-icon-bubble').load(location.href + " #cart-icon-bubble");
}

checkLimitedCartProducts(false);


$(".testimonial-slider").slick({
  infinite: true,
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    { breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    { breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    { breakpoint: 575,
      settings: {
        slidesToShow: 1
      }
    }]
})